import { getImage } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge";
import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "./Button"; // Custom Button component
import { SafeHtmlParser } from "./SafeHtmlParser";
import gsap from "gsap";
import useOnScreen from "./use-on-screen";

const StatsLayout1 = ({
	heading,
	backgroundImage,
	stat1,
	stat2,
	stat3,
	button,
}) => {
	// Get the background image (if any)
	const bgImage = backgroundImage ? getImage(backgroundImage) : null;
	// Combine the stats into an array
	const stats = [stat1, stat2, stat3];

	// Attach a ref to the outer container so we can trigger animations when scrolled into view
	const containerRef = useRef(null);
	const isVisible = useOnScreen(containerRef, "10px");

	useEffect(() => {
		if (isVisible && containerRef.current) {
			// Animate the left line(s): scaleY from 0 to 1 (growing from the bottom)
			const lines = containerRef.current.querySelectorAll(".stat-line");
			gsap.to(lines, {
				scaleY: 1,
				duration: 1,
				ease: "power2.out",
				stagger: 0.2,
				delay: 1,
			});
			// Animate the text: slide in from left (x: -50 to 0) and fade in (opacity 0 to 1)
			const texts = containerRef.current.querySelectorAll(".stat-text");
			gsap.to(texts, {
				x: 0,
				opacity: 1,
				duration: 1,
				ease: "power2.out",
				stagger: 0.3,
				delay: 1,
			});
		}
	}, [isVisible]);

	return (
		<BgImage className="py-5 pb-lg-7 pt-md-8 position-relative" image={bgImage}>
			<div
				style={{
					background:
						"linear-gradient(180deg, rgba(0, 18, 33, 0.00) 0%, #001221 83.8%), linear-gradient(0deg, rgba(0, 48, 75, 0.25) 0%, rgba(0, 48, 75, 0.25) 100%)",
				}}
				className="position-absolute h-100 w-100 start-0 top-0"
			></div>
			<Container
				style={{ zIndex: 2 }}
				className="pt-lg-10 position-relative"
				ref={containerRef}
			>
				{/* Heading */}
				<Row>
					<Col>
						<h2 className="text-white display-3">{heading}</h2>
					</Col>
				</Row>

				{/* Stats Section */}
				<Row className="mt-5 gy-3 h-100">
					{stats.map(
						(stat, index) =>
							stat && (
								<Col style={{ minHeight: "100%" }} lg={4} sm={12} key={index}>
									<div
										className="stat-box pe-lg-4 ps-lg-4 ps-3 h-100 text-white py-1"
										style={{ position: "relative" }}
									>
										{/* Left border line element (initially scaled to 0) */}
										<div
											className="stat-line"
											style={{
												position: "absolute",
												left: 0,
												top: 0,
												bottom: 0,
												width: "4px",
												background: "#73B43E",
												transform: "scaleY(0)",
												transformOrigin: "bottom",
											}}
										></div>
										{/* Text content, initially shifted to left and transparent */}
										<div
											className="stat-text"
											style={{
												paddingLeft: "1rem",
												transform: "translateX(-50px)",
												opacity: 0,
											}}
										>
											{stat.heading && (
												<h3>
													<SafeHtmlParser htmlContent={stat.heading} />
												</h3>
											)}
											<p className="outfit-regular">{stat.body}</p>
										</div>
									</div>
								</Col>
							)
					)}
				</Row>

				{/* Learn More Button */}
				{button && (
					<Row className="mt-5">
						<Col className="text-center">
							<Button
								width="w-100 w-md-auto"
								colour="#73B43E"
								text={button.title}
								link={button.url}
								isOutline={false}
							/>
						</Col>
					</Row>
				)}
			</Container>
		</BgImage>
	);
};

export default StatsLayout1;
